/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-10-21 15:41:00
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-10-21 17:21:03
 */
import Vue from 'vue'

Vue.directive('watermark', (el, binding) => {
    function addWaterMarker(str, parentNode, font, textColor) {// 水印文字，父元素，字体，文字颜色
        var can = document.createElement('canvas');
        parentNode.appendChild(can);
        can.width = 350;
        can.height = 350;
        can.style.display = 'none';
        var cans = can.getContext('2d');
        cans.rotate(-20 * Math.PI / 180);
        cans.font = font || "16px 方正黑体";
        cans.fillStyle = textColor || "rgba(180, 180, 180, 0.3)";
        cans.textAlign = 'left';
        cans.textBaseline = 'Middle';
        cans.fillText(str, can.width / 3, can.height / 2);
        parentNode.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
    }
    addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor)
})


// WEBPACK FOOTER //
// ./src/utils/directives.js